import { LadingSchesule } from "./ladingSchedule.model";
import { CustomExportFileModel } from "./customExportFile.model";

export class ShipmentFilterViewModel {
    OrderDateFrom: any = new Date();
    OrderDateTo: any = new Date();
    isEdit: boolean;
    isLo: boolean;
    CreatedBy: string;
    PickupType: any;
    ShipmentNumberW: any;
    ShipmentNumberS: any;
    PickUserId: any;
    IsSaveWarehouse: any;
    shipmentId: any;
    IsSendSMSR: any;
    IsCallPhoneR: any;
    ReceiverId: any;
    ReceiverName: any;
    receiverPhone: any;
    ShipmentNumber: any;
    FromProvinceId: any;
    ToProvinceId: any;
    RequestShipmentId: number;
    ShipmentNumberListSelect: string[];
    ShipmentNumberListUnSelect: string[];
    SenderId: any;
    SenderPhone: any;
    SenderName: any;
    WeightFrom: any;
    ServiceId: any;
    WeightTo: any;
    PaymentTypeId: any;
    ShipmentStatusId: any;
    ShipmentStatusIds: any;
    SearchText: any;
    Type: any;
    pageSize: any = 20;
    pageNumber: any = 1;
    Cols: any;
    FromHubId: any;
    FromPoHubId: number;
    FromDistrictId: any;
    FromWardId: any;
    CurrentHubId: any;
    DeliveryUserId: any;
    ToHubId: any;
    ToPohubId: any;
    IsSuccess: boolean;
    IsExistInfoDelivery: boolean;
    IsExistImagePickup: boolean;
    CurrentHubDelivery: any;
    isEnabled: boolean;
    currentEmpId: any;
    receiveHubId: any;
    listGoodsId: any;
    transferUserId: number;
    // times delivery
    numIssueDelivery?: number;
    endNumDelivery?: number;
    handlingEmpId?: number;
    uploadExcelHistoryId?: number;
    // sort theo thứ tự giảm dần = true, tăng dần = false, mặc định là giảm dần
    isSortDescending: boolean = true;
    isBox: boolean = null;
    groupStatusId: number;
    isPrintBill: boolean;
    deadlineTypeId: number = null;
    referencesCode: string;
    isGroupEmp: boolean = false;
    TypePickup: any;
    //
    id: any;
    isReturn: boolean;
    list_package: ShipmentFilterViewModel[] = [];
    statusCheck = false;
    shipmentStatusId: number;
    isPickupWH: boolean;
    isSaveWarehouse: boolean;
    isExpan: boolean = false;
    isRoutingLong: boolean;
    ReceiverIdentityCard: string;
    ReceiverInsteadName: string;
    ReceiverInsteadIdentityCard: string;
    //
    IsSaveWare: boolean;
    IsContact?: boolean;
    IsSendSMS?: boolean;
    ContactUs: string;
    typeEditInfoId: number;
    totaalItem: number;
    structureCode: any
    structureId: number;
    shipmentIds: any[];
    //
    customExportFile: CustomExportFileModel = new CustomExportFileModel();
    //
    indexOfInBox: number;
    saveWarehouseStatus: number;
    pickUserId: number;
    pickDriverUserId: number;
    truckId: number;
    shopCode: string;
    reShipmentNumber: string;
    shipmentContactId: number;
    debitId: number;
    listCustomerPaymentId: number;
    isPaidPrice: boolean;
    isDeliveryGTN: boolean;

    searchTextSender: string;
    searchTextReceiver: string;
    shipmentNumberSs: string[] = [];
    typeGTN: boolean;
    isShipmentContract: boolean;
    shipmentContractTypeId: number;
    createdById: any;
    EmpId?: number;
    isCNNG: boolean;
}